var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeploySpot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m508.909 491.032h-505.818c-1.707 0-3.091-1.384-3.091-3.091v-379.571c0-1.707 1.384-3.091 3.091-3.091h505.819c1.707 0 3.091 1.384 3.091 3.091v379.572c-.001 1.707-1.385 3.09-3.092 3.09z",
    fill: "#f2fbff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m25.755 462.187v-328.063c0-1.707 1.384-3.091 3.091-3.091h454.31c1.707 0 3.091 1.384 3.091 3.091v328.063c0 1.707-1.384 3.091-3.091 3.091h-454.311c-1.707 0-3.09-1.384-3.09-3.091z",
    fill: "#80d261"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m274.028 348.119h27.3v-99.928h-27.3c-2.845 0-5.151 2.306-5.151 5.151v89.626c0 2.845 2.306 5.151 5.151 5.151z",
    fill: "#68ca44"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m268.877 217.286c0 2.845 2.306 5.151 5.151 5.151h27.3v-88.313c0-1.707 1.384-3.091 3.091-3.091h-35.541v86.253z",
    fill: "#68ca44"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m301.328 462.187v-88.314h-27.3c-2.845 0-5.151 2.306-5.151 5.151v86.253h-1.03 36.571c-1.706.001-3.09-1.383-3.09-3.09z",
    fill: "#68ca44"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m59.235 462.187v-328.063c0-1.707 1.384-3.091 3.091-3.091h-33.481c-1.707 0-3.091 1.384-3.091 3.091v328.063c0 1.707 1.384 3.091 3.091 3.091h33.481c-1.707 0-3.091-1.384-3.091-3.091z",
    fill: "#68ca44"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m268.877 217.286c0 2.845 2.306 5.151 5.151 5.151h54.085v-35.921c0-2.845-2.306-5.151-5.151-5.151h-54.085z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m274.028 222.437h27.3v-41.071h-32.451v35.921c0 2.844 2.306 5.15 5.151 5.15z",
    fill: "#f2fbff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m277.119 410.066c-2.804 0-5.555.221-8.241.64v54.572h61.241c.029-.717.055-1.434.055-2.157-.001-29.302-23.754-53.055-53.055-53.055z",
    fill: "#01c0fa"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m301.328 462.187v-46.271c-7.26-3.731-15.485-5.85-24.209-5.85-2.804 0-5.555.221-8.241.64v54.572h35.54c-1.707-.001-3.09-1.384-3.09-3.091z",
    fill: "#08a9f1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m74.688 285.278h-48.933v-49.313h45.843c1.707 0 3.091 1.384 3.091 3.091v46.222z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m25.755 235.965h33.481v49.313h-33.481z",
    fill: "#f2fbff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m243.123 280.127v-81.895c-54.928.617-101.255 37.051-116.712 87.046h111.561c2.845 0 5.151-2.306 5.151-5.151z",
    fill: "#01c0fa"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m243.123 221.55v-23.317c-54.928.617-101.255 37.051-116.712 87.046h30.243c17.326-32.717 48.903-56.712 86.469-63.729z",
    fill: "#08a9f1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m486.245 248.192v-25.755h-212.217c-2.845 0-5.151-2.306-5.151-5.151v-86.253h-25.755v149.094c0 2.845-2.306 5.151-5.151 5.151h-212.216v25.755h212.217c2.845 0 5.151 2.306 5.151 5.151v149.094h25.755v-86.253c0-2.845 2.306-5.151 5.151-5.151h212.217v-25.755h-212.218c-2.845 0-5.151-2.306-5.151-5.151v-89.626c0-2.845 2.306-5.151 5.151-5.151h212.217z",
    fill: "#faea5e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m338.414 318.38h-36.056c-1.707 0-3.091-1.384-3.091-3.091v-36.056c0-1.707 1.384-3.091 3.091-3.091h36.056c1.707 0 3.091 1.384 3.091 3.091v36.056c0 1.707-1.384 3.091-3.091 3.091z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m319.871 315.289v-36.056c0-1.707 1.384-3.091 3.091-3.091h-20.604c-1.707 0-3.091 1.384-3.091 3.091v36.056c0 1.707 1.384 3.091 3.091 3.091h20.604c-1.707 0-3.091-1.384-3.091-3.091z",
    fill: "#f2fbff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m458.946 195.788h-36.056c-1.707 0-3.091-1.384-3.091-3.091v-36.056c0-1.707 1.384-3.091 3.091-3.091h36.056c1.707 0 3.091 1.384 3.091 3.091v36.056c-.001 1.708-1.384 3.091-3.091 3.091z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m440.402 192.698v-36.056c0-1.707 1.384-3.091 3.091-3.091h-20.604c-1.707 0-3.091 1.384-3.091 3.091v36.056c0 1.707 1.384 3.091 3.091 3.091h20.604c-1.707-.001-3.091-1.384-3.091-3.091z",
    fill: "#f2fbff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m416.188 417.128 32.158-55.699c15.482-26.816-3.87-60.335-34.834-60.335-30.964 0-50.316 33.519-34.834 60.335l32.158 55.699c1.188 2.061 4.162 2.061 5.352 0z",
    fill: "#fd4755"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m408.353 356.359c-5.406-2.077-9.25-7.304-9.25-13.441 0-5.62 3.225-10.476 7.919-12.852 3.319-11.236 11.458-20.87 22.564-25.686-4.845-2.101-10.254-3.286-16.074-3.286-30.964 0-50.316 33.519-34.834 60.335l32.158 55.699c1.189 2.06 4.163 2.06 5.353 0l13.397-23.205-18.76-32.494c-.963-1.667-1.775-3.361-2.473-5.07z",
    fill: "#fb2b3a"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 413.511,
    cy: 342.918,
    fill: "#fff",
    r: 14.409
  })), /*#__PURE__*/React.createElement("path", {
    d: "m409.183 342.918c0-6.182 3.9-11.439 9.368-13.484-1.571-.588-3.264-.924-5.04-.924-7.958 0-14.408 6.451-14.408 14.409s6.451 14.409 14.408 14.409c1.776 0 3.469-.337 5.04-.924-5.468-2.047-9.368-7.304-9.368-13.486z",
    fill: "#f2fbff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m99.58 375.867 33.285-57.651c16.025-27.755-4.006-62.45-36.055-62.45-32.049 0-52.08 34.694-36.055 62.45l33.285 57.651c1.231 2.133 4.309 2.133 5.54 0z",
    fill: "#fd4755"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m89.902 312.266c-4.756-2.492-8.005-7.469-8.005-13.21 0-5.193 2.657-9.761 6.682-12.432 3.327-12.208 12.121-22.705 24.226-27.712-4.851-2.007-10.224-3.146-15.995-3.146-32.049 0-52.08 34.694-36.055 62.449l33.285 57.651c1.231 2.133 4.309 2.133 5.541 0l13.224-22.906-20.06-34.745c-1.128-1.953-2.064-3.942-2.843-5.949z",
    fill: "#fb2b3a"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 96.81,
    cy: 299.056,
    fill: "#fff",
    r: 14.914
  })), /*#__PURE__*/React.createElement("path", {
    d: "m92 299.056c0-6.46 4.115-11.945 9.862-14.017-1.58-.57-3.276-.896-5.052-.896-8.236 0-14.913 6.677-14.913 14.914s6.677 14.914 14.913 14.914c1.776 0 3.472-.327 5.052-.896-5.747-2.074-9.862-7.558-9.862-14.019z",
    fill: "#f2fbff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 175.646,
    cy: 398.734,
    fill: "#01c0fa",
    r: 35.026
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m171.525 398.734c0-13.797 7.98-25.725 19.573-31.435-4.662-2.296-9.905-3.591-15.453-3.591-19.344 0-35.026 15.682-35.026 35.026s15.682 35.026 35.026 35.026c5.548 0 10.791-1.295 15.453-3.591-11.593-5.71-19.573-17.638-19.573-31.435z",
    fill: "#08a9f1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m25.755 403.467v58.72c0 1.707 1.384 3.091 3.091 3.091h58.72c-.001-34.137-27.674-61.811-61.811-61.811z",
    fill: "#01c0fa"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m28.845 465.278h33.481c-1.707 0-3.091-1.384-3.091-3.091v-48.855c-9.65-6.233-21.138-9.865-33.481-9.865v58.72c.001 1.707 1.384 3.091 3.091 3.091z",
    fill: "#08a9f1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m483.155 472.778h-454.31c-5.839 0-10.59-4.751-10.59-10.59v-328.064c0-5.839 4.751-10.59 10.59-10.59h454.311c5.839 0 10.59 4.751 10.59 10.59v328.063c-.001 5.84-4.752 10.591-10.591 10.591zm-449.9-15h445.49v-319.244h-445.49z",
    fill: "#99e6fc"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m147.311 192.549 48.193-83.473c22.609-39.159-5.652-88.108-50.869-88.108-45.217 0-73.478 48.949-50.869 88.108l48.193 83.473c1.188 2.06 4.162 2.06 5.352 0z",
    fill: "#fd4755"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m134.009 103.102c-7.688-3.887-12.963-11.854-12.963-21.057 0-8.288 4.278-15.573 10.744-19.78 5.222-16.584 17.661-30.651 34.478-37.26-6.596-2.592-13.864-4.038-21.634-4.038-45.217 0-73.478 48.949-50.869 88.108l48.193 83.473c1.19 2.06 4.163 2.06 5.353 0l18.957-32.835-29.236-50.638c-1.136-1.968-2.139-3.962-3.023-5.973z",
    fill: "#fb2b3a"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 144.634,
    cy: 82.045,
    fill: "#fff",
    r: 23.588
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m142.68 82.045c0-9.127 5.187-17.037 12.771-20.959-3.241-1.676-6.917-2.629-10.817-2.629-13.027 0-23.588 10.561-23.588 23.588s10.561 23.588 23.588 23.588c3.9 0 7.576-.952 10.817-2.628-7.584-3.923-12.771-11.833-12.771-20.96z",
    fill: "#f2fbff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeploySpot);
export default __webpack_public_path__ + "static/media/deploySpot.da2786a3c8f3484e706900282bf58b3e.svg";
export { ForwardRef as ReactComponent };